export const noDataMessage = {
  background: "#f1f1f1",
  display: "flex",
  margin: "auto",
  width: "90%",
  justifyContent: "center",
  alignItems: "center",
  fontSize: "0.8rem",
  padding: "10px",
};

export const manualInput = {
  display: "flex",
  justifyContent: "space-between",
};

export const container = {
  margin: "20px 0",
};
